export default __webpack_public_path__ + "static/media/Meditation_Yoga.e4e4855f.svg";